/* ════ CONFETTI ════════════════════════════════════════════ */
// A short celebratory burst on a throwaway canvas. No library, removes itself
// when done, and is skipped for anyone who prefers reduced motion.
const COLOURS = ['#ED1F23', '#C2141A', '#FFB400', '#1A6FD4', '#059669', '#B5379A', '#FF7A45'];

export function confetti({ x, y, count = 140, emoji = [] } = {}) {
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
  const W = innerWidth, H = innerHeight, dpr = window.devicePixelRatio || 1;
  const cv = document.createElement('canvas');
  cv.style.cssText = 'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:9999';
  cv.width = W * dpr; cv.height = H * dpr;
  document.body.appendChild(cv);
  const ctx = cv.getContext('2d'); ctx.scale(dpr, dpr);
  const ox = x ?? W / 2, oy = y ?? H * 0.6;

  const bit = kind => {
    const a = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 0.95, v = 7 + Math.random() * 10;
    return {
      x: ox, y: oy, vx: Math.cos(a) * v, vy: Math.sin(a) * v, r: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.35,
      w: 5 + Math.random() * 6, h: 8 + Math.random() * 8, c: COLOURS[Math.random() * COLOURS.length | 0], kind,
      e: emoji[Math.random() * emoji.length | 0], s: 18 + Math.random() * 10,
    };
  };
  const parts = [
    ...Array.from({ length: count }, () => bit(Math.random() < 0.25 ? 'dot' : 'strip')),
    ...(emoji.length ? Array.from({ length: 14 }, () => bit('emoji')) : []),
  ];

  const t0 = performance.now(), LIFE = 2600;
  const frame = now => {
    const t = now - t0;
    ctx.clearRect(0, 0, W, H);
    ctx.globalAlpha = Math.max(0, 1 - Math.max(0, t - LIFE * 0.6) / (LIFE * 0.4));   // fade out over the last 40%
    for (const p of parts) {
      p.vy += 0.3; p.vx *= 0.985; p.vy *= 0.985; p.x += p.vx; p.y += p.vy; p.r += p.vr;
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.kind === 'emoji' ? p.r * 0.3 : p.r);
      if (p.kind === 'emoji') { ctx.font = `${p.s}px serif`; ctx.textAlign = 'center'; ctx.fillText(p.e, 0, 0); }
      else if (p.kind === 'dot') { ctx.fillStyle = p.c; ctx.beginPath(); ctx.arc(0, 0, p.w / 2, 0, 6.28); ctx.fill(); }
      else { ctx.fillStyle = p.c; ctx.scale(1, Math.cos(p.r * 2)); ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h); }   // flutter
      ctx.restore();
    }
    if (t < LIFE) requestAnimationFrame(frame); else cv.remove();
  };
  requestAnimationFrame(frame);
}

// Burst from the middle of an element (e.g. the button that was just clicked).
export function confettiFrom(el, opts = {}) {
  const b = el?.getBoundingClientRect?.();
  confetti({ ...opts, ...(b && b.width ? { x: b.left + b.width / 2, y: b.top + b.height / 2 } : {}) });
}
